import {Container} from "./components/Container";
import {useEffect, useState} from "react";
import {log} from "./utils/log";
import {ChatTransportClient} from "./service/ChatTransportClient";

function App() {
    const [firstSetup, setFirstSetup] = useState(false);
    const [load, setLoad] = useState(true);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const dialogId = params.get("dialogId");
        if(!dialogId){
            return;
        }
        const client = new ChatTransportClient(dialogId, {
            onMessage: (res) => {
                if(res.type === 'all_dialog_messages'){
                    setMessages(res.data.data.reverse());
                    setLoad(false);
                }else if(res.type === 'new_dialog_message'){
                    const currentScroll = (document.documentElement.scrollTop || document.body.scrollTop) + window.innerHeight;

                    if(currentScroll >= document.documentElement.scrollHeight || currentScroll >= document.body.scrollHeight){
                        console.log('Фиксируем, что нужно отскролить вниз')
                        setFirstSetup(false)
                    }
                    setMessages((mes) => {
                        const messageIdx = mes.findIndex((it) => it.id === res.message.id);
                        if(messageIdx >= 0){
                            const message = mes[messageIdx];

                            mes.splice(messageIdx, 1, {...message, ...res.message, status: message.status});
                            return [...mes];
                        }else{
                            return [...mes, res.message]
                        }
                    });
                }else if(res.type === 'update_message'){
                    setMessages((mes) => {
                        const messageIdx = mes.findIndex((it) => it.id === res.message.id);
                        if(messageIdx >= 0){
                            const message = mes[messageIdx];
                            mes.splice(messageIdx, 1, {...message, ...res.message});
                            return [...mes];
                        }else{
                            return [...mes, res.message]
                        }
                    })
                }
            },
            onOpen: () => {
                console.log('open')
            },
            onClose: (event) => {
                if(event){
                    if (event.wasClean) {
                        log([`Соединение закрыто чисто, код=${event.code} причина=${event.reason}`]);
                    } else {
                        log([`Соединение прервано код=${event.code} причина=${event.reason}`]);
                    }
                }
                console.log('close');
            },
            onError: (e) => {
                log([`Возникла ошибка ${e.messages}`]);
            }
        });

        client.run()

        return () => {
            client.stop();
        }
    }, [])

    useEffect(() => {
        if(!firstSetup && messages.length !== 0){
            setTimeout(() => {
                //window.scrollTo(0, document.body.scrollHeight);

                document.documentElement.scrollTop = document.querySelector('.chat-container')?.scrollHeight;
                document.body.scrollTop = document.querySelector('.chat-container')?.scrollHeight;

                setFirstSetup(true)
            }, 1);
        }
    }, [firstSetup, messages]);

  return (
    <div className="App">
        {load && <div className="loader-container">
            <span className="loader"/>
        </div>}
        {!load && <Container messages={messages}/>}
    </div>
  );
}

export default App;
